import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { NotificationTypes, NotificationLevels } from '@adsk/bim360-matrix-react-components';
import T from 'i18n-react';
import { connect } from '../../../../../redux/connect';
import { showNotificationAction } from '../../../../../redux/actions';
import TextFieldInlineEdit from '../../../../TextFieldInlineEdit';
import { issueAttributesType } from '../../../../../constants/proptype-validation';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../../../constants/issue-attribute-names';
import IssueFieldInlineEdit from '../../../../IssueFieldInlineEdit';
import {
  rfiCustomIdentifierAllowedCharactersValidator,
  rfiCustomIdentifierMaxLengthValidator,
  presenceValidator,
} from '../../../../../utils/validation-helpers';
import { CUSTOM_IDENTIFIER_CLIENT_VALIDATION_TYPES } from '../../../../../constants/custom-identifier';
import { STATUS_SUBMITTED } from '../../../../../constants/status-types';

export class PureRfiCustomIdentifierInlineEdit extends PureComponent {
  constructor(props) {
    super(props);

    this.handleValidation = this.handleValidation.bind(this);
    this.getErrorMessage = this.getErrorMessage.bind(this);

    this.clientValidationErrorMessagesMapping = {
      [CUSTOM_IDENTIFIER_CLIENT_VALIDATION_TYPES.ALLOWED_CHARACTERS]: T.translate(
        'new.rfiCustomIdentifierAllowedCharactersValidationMessage'
      ),
      [CUSTOM_IDENTIFIER_CLIENT_VALIDATION_TYPES.MAX_LENGTH]: T.translate(
        'new.rfiCustomIdentifierMaxCharactersValidationMessage'
      ),
      [CUSTOM_IDENTIFIER_CLIENT_VALIDATION_TYPES.REQUIRED]: T.translate(
        'new.rfiCustomIdentifierFieldRequired'
      ),
    };
  }

  getErrorMessage(value) {
    const { issue } = this.props;
    const isSubmittedRfi = issue[ISSUE_ATTRIBUTE_NAMES.STATUS] === STATUS_SUBMITTED;

    // Enable to remove custom-identifier to submitted RFIs
    if (!isSubmittedRfi && !presenceValidator(value)) {
      return this.clientValidationErrorMessagesMapping[
        CUSTOM_IDENTIFIER_CLIENT_VALIDATION_TYPES.REQUIRED
      ];
    }
    if (!rfiCustomIdentifierMaxLengthValidator(value, 15)) {
      return this.clientValidationErrorMessagesMapping[
        CUSTOM_IDENTIFIER_CLIENT_VALIDATION_TYPES.MAX_LENGTH
      ];
    }
    if (!rfiCustomIdentifierAllowedCharactersValidator(value)) {
      return this.clientValidationErrorMessagesMapping[
        CUSTOM_IDENTIFIER_CLIENT_VALIDATION_TYPES.ALLOWED_CHARACTERS
      ];
    }
    return null;
  }

  handleValidation(value) {
    const { issue, showNotification } = this.props;
    const trimmedValue = value.trim();
    const valueChanged = trimmedValue !== issue[ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER];

    if (valueChanged) {
      const errorMessage = this.getErrorMessage(trimmedValue);
      const isValid = !errorMessage;

      // if value was changed but the value is invalid - show error snack bar
      if (!isValid) {
        showNotification({
          type: NotificationTypes.SNACKBAR,
          level: NotificationLevels.ERROR,
          message: errorMessage,
        });
      }
      return !isValid;
    }
    // if value was not changed we would like to prevent BE update
    return true;
  }

  render() {
    const { issue } = this.props;

    return (
      <TextFieldInlineEdit
        issue={issue}
        attributeName={ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER}
        className="RfiCustomIdentifierInlineEdit"
        data-testid="RfiCustomIdentifierInlineEdit"
        styleType={IssueFieldInlineEdit.StyleTypes.DEFAULT}
        inputValidator={this.handleValidation}
        hideErrorMessage
        showLoaderOnUpdate
        placeholder={`#${T.translate('unspecifiedValue')}`}
      />
    );
  }
}

PureRfiCustomIdentifierInlineEdit.displayName = 'RfiCustomIdentifierInlineEdit';
PureRfiCustomIdentifierInlineEdit.defaultProps = {
  issue: undefined,
};
PureRfiCustomIdentifierInlineEdit.propTypes = {
  issue: issueAttributesType,
  showNotification: PropTypes.func.isRequired,
};

export default connect(null, {
  showNotification: showNotificationAction,
})(PureRfiCustomIdentifierInlineEdit);
